import { GlButton, GlLink, GlSprintf, GlTooltipDirective, GlIcon, GlModalDirective, GlIntersectionObserver, GlToastMixin } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, s__ } from '~/locale';
import TimeAgo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import PageHeading from '~/vue_shared/components/page_heading.vue';
import wikiPageQuery from '~/wikis/graphql/wiki_page.query.graphql';
import wikiPageSubscribeMutation from '~/wikis/graphql/wiki_page_subscribe.mutation.graphql';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import WikiSidebarToggle from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_sidebar_toggle.vue?vue3';
import WikiMoreDropdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_more_dropdown.vue?vue3';
import RestoreVersionModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/restore_version_modal.vue?vue3';
import WikiStickyHeader from '/builds/gitlab/gitlab-ee/app/assets/javascripts/wikis/components/wiki_sticky_header.vue?vue3';
export default {
    name: 'WikiHeader',
    components: {
        WikiSidebarToggle,
        GlButton,
        GlIcon,
        GlLink,
        GlSprintf,
        GlIntersectionObserver,
        WikiMoreDropdown,
        TimeAgo,
        PageHeading,
        RestoreVersionModal,
        WikiStickyHeader
    },
    directives: {
        GlTooltip: GlTooltipDirective,
        GlModal: GlModalDirective
    },
    mixins: [
        GlToastMixin
    ],
    inject: {
        pageHeading: {
            default: null
        },
        showEditButton: {
            default: null
        },
        showRestoreVersionButton: {
            default: null
        },
        isPageTemplate: {
            default: null
        },
        lastVersion: {
            default: null
        },
        pageVersion: {
            default: null
        },
        authorUrl: {
            default: null
        },
        createFromTemplateUrl: {
            default: null
        },
        queryVariables: {
            default: null
        }
    },
    emits: [
        'is-editing'
    ],
    apollo: {
        wikiPage: {
            query: wikiPageQuery,
            variables () {
                return {
                    ...this.queryVariables,
                    skipDiscussions: true
                };
            }
        }
    },
    data () {
        return {
            changingSubState: false,
            wikiPage: {},
            isStickyHeaderShowing: false
        };
    },
    computed: {
        showCreateFromTemplateButton () {
            return this.showEditButton && this.isPageTemplate && this.createFromTemplateUrl;
        },
        editTooltipText () {
            return this.isPageTemplate ? this.$options.i18n.editTemplate : this.$options.i18n.editPage;
        },
        editTooltip () {
            return `${this.editTooltipText} <kbd class='flat gl-ml-2' aria-hidden=true>e</kbd>`;
        },
        subscribeItem () {
            return {
                text: this.wikiPage?.subscribed ? __('Notifications are on') : __('Notifications are off'),
                icon: this.wikiPage?.subscribed ? 'notifications' : 'notifications-off'
            };
        },
        isStickyHeaderVisible () {
            // hide sticky when in editing path, title changes and Edit button is irrelevant , also hide when restore version button is shown as it appears in the same place and Edit button is hidden
            return this.isStickyHeaderShowing && !this.isEditingPath && !this.showRestoreVersionButton;
        }
    },
    mounted () {
        if (this.showEditButton) {
            document.addEventListener('keyup', this.onKeyUp);
        }
    },
    destroyed () {
        if (this.showEditButton) {
            document.removeEventListener('keyup', this.onKeyUp);
        }
    },
    methods: {
        hideStickyHeader () {
            this.isStickyHeaderShowing = false;
        },
        showStickyHeader () {
            this.isStickyHeaderShowing = true;
        },
        onKeyUp (event) {
            const { tagName, isContentEditable } = event.currentTarget.activeElement;
            if (/input|textarea/i.test(tagName) || isContentEditable) return false;
            if (event.key === 'e') {
                this.setEditingMode();
            }
            return false;
        },
        setEditingMode () {
            this.$emit('is-editing', true);
        },
        async toggleSubscribe () {
            if (this.changingSubState) return;
            this.changingSubState = true;
            const newSubState = !this.wikiPage.subscribed;
            try {
                await this.$apollo.mutate({
                    mutation: wikiPageSubscribeMutation,
                    variables: {
                        id: this.wikiPage.id,
                        subscribed: newSubState
                    },
                    optimisticResponse: {
                        wikiPageSubscribe: {
                            errors: [],
                            wikiPage: {
                                id: this.wikiPage.id,
                                subscribed: newSubState
                            }
                        }
                    }
                });
                const message = newSubState ? __('Notifications turned on') : __('Notifications turned off');
                this.$toast.show(message);
            } catch (error) {
                this.handleSubscribeError(error, newSubState);
            }
            this.changingSubState = false;
        },
        handleSubscribeError (error, newSubState) {
            const message = newSubState ? __('An error occurred while subscribing to this page. Please try again later.') : __('An error occurred while unsubscribing from this page. Please try again later.');
            this.$toast.show(message);
            Sentry.captureException(error);
        }
    },
    i18n: {
        edit: __('Edit'),
        restoreText: __('Restore this version'),
        cancelText: __('Cancel'),
        newPage: s__('Wiki|New page'),
        editPage: s__('Wiki|Edit page'),
        newTemplate: s__('Wiki|New template'),
        editTemplate: s__('Wiki|Edit template'),
        newSidebar: s__('Wiki|New custom sidebar'),
        editSidebar: s__('Wiki|Edit custom sidebar'),
        lastEdited: s__('Wiki|Last edited by %{author} %{timeago}'),
        createFromTemplate: s__('Wiki|Create from template'),
        createFromTemplateTitle: s__('Wiki|Create a new wiki page using this template')
    },
    modal: {
        restoreVersionModalId: 'wiki-restore-version-modal'
    }
};
